import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Construction } from "lucide-react";

export default function UnderConstructionPage({ title = "This Feature", description }) {
  return (
    <div className="space-y-6" data-testid="under-construction-page">
      <h1 className="font-heading text-3xl font-bold tracking-tight">{title}</h1>
      <Card>
        <CardContent className="py-16 text-center">
          <div className="mx-auto mb-4 p-5 rounded-full bg-amber-500/10 w-fit">
            <Construction className="h-12 w-12 text-amber-500" />
          </div>
          <h2 className="text-xl font-semibold mb-2">Under Construction</h2>
          <p className="text-muted-foreground max-w-md mx-auto">
            {description || `${title} is currently being built and will be available soon. Stay tuned for updates!`}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
